import React from 'react';
import './Footer.css'

const Footer = () => {
    return (
        <div className="footer">
            <p>&copy;  2021 MediNova Health Center, All Rights Reserved. Design By AKTARUZZAMAN RIDOY</p>
            <i className="fab fa-facebook"></i>
            <i className="fab fa-twitter mx-3"></i>
            <i className="fab fa-dribbble"></i>
            <i className="fab fa-linkedin-in mx-3"></i>
        </div>
    );
};

export default Footer;